import { render, staticRenderFns } from "./ShortcutTip.vue?vue&type=template&id=12fdd4af&scoped=true&"
import script from "./ShortcutTip.vue?vue&type=script&lang=js&"
export * from "./ShortcutTip.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutTip.vue?vue&type=style&index=0&id=12fdd4af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fdd4af",
  null
  
)

export default component.exports